import { AxiosPromise } from "axios";
import { ApiRequestAdapter } from "../../../common/api/ApiRequestAdapter";
import { apiService } from "../../../common/api/apiService";
import { HttpMethod } from "../../../common/api/http";
import { PageSizes } from "../../../common/constants";
import { EntityIdObject, EntityObject } from "../../../common/types";
import { CalcType } from "../enums";
import {
  CalcBlacklist,
  CalcBlacklistFilterPageRequest,
  CalcBlacklistFilterPageResult,
  CreateUpdateCalcBlacklist,
} from "./types";

const FILTER_CALC_BLACKLISTS = ApiRequestAdapter.create("/calculators/blacklists/filter", HttpMethod.POST);
const CREATE_CALC_BLACKLIST = ApiRequestAdapter.create("/calculators/blacklists", HttpMethod.POST);
const UPDATE_CALC_BLACKLIST = ApiRequestAdapter.create("/calculators/blacklists/{0}", HttpMethod.PUT);
const DELETE_CALC_BLACKLIST = ApiRequestAdapter.create("/calculators/blacklists/{0}", HttpMethod.DELETE);

export const calcBlackListApi = {
  filterCalcBlacklists: (request: CalcBlacklistFilterPageRequest): AxiosPromise<CalcBlacklistFilterPageResult> => {
    return apiService.post(FILTER_CALC_BLACKLISTS.url, request);
  },
  createCalcBlacklist: (request: CreateUpdateCalcBlacklist): AxiosPromise<CalcBlacklist> => {
    return apiService.post(CREATE_CALC_BLACKLIST.url, request);
  },
  updateCalcBlacklist: (request: EntityObject<CreateUpdateCalcBlacklist>): AxiosPromise<CalcBlacklist> => {
    return apiService.put(UPDATE_CALC_BLACKLIST.getParametrizedUrl(request.id), request.object);
  },
  deleteCalcBlacklist: (request: EntityIdObject): AxiosPromise => {
    return apiService.delete(DELETE_CALC_BLACKLIST.getParametrizedUrl(request.id));
  },
};

export const DEFAULT_FILTER_CALC_BLACK_LISTS_QUERY_PARAMS: Required<CalcBlacklistFilterPageRequest> = {
  pageIndex: 0,
  pageSize: PageSizes.LARGE,
  institutionIds: [],
  agentIds: [],
  calcType: "" as CalcType,
};
